(() => {
  const MOBILE = window.matchMedia('(max-width: 767px)');

  class C365Search extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('[data-srch-input]');
      const clear = this.querySelector('[data-srch-clear]');
      input?.addEventListener('input', () => (clear.hidden = !input.value));
      clear?.addEventListener('click', () => {
        input.value = '';
        clear.hidden = true;
        input.focus();
      });

      const form = this.querySelector('[data-srch-form]');
      if (!form) return;
      const desktop = this.querySelector('[data-srch-desktop-filters]');
      const sheet = this.querySelector('[data-sheet]');
      const sheetBody = this.querySelector('[data-sheet-body]');

      // One set of filter inputs, moved between the sidebar and the mobile sheet so the form never
      // submits duplicate params.
      const place = () => {
        const target = MOBILE.matches ? sheetBody : desktop;
        while ((MOBILE.matches ? desktop : sheetBody).firstChild) target.appendChild((MOBILE.matches ? desktop : sheetBody).firstChild);
      };
      place();
      MOBILE.addEventListener('change', () => {
        sheet.hidden = true;
        place();
      });

      // Desktop applies filters immediately; on mobile they apply from the sheet's "Show results".
      form.addEventListener('change', (e) => {
        if (!e.target.matches('[data-autosubmit]')) return;
        if (MOBILE.matches && e.target.name !== 'sort_by') return;
        form.requestSubmit();
      });
      form.addEventListener('submit', () => {
        form.querySelectorAll('.c365-srch-price input').forEach((i) => {
          if (i.value === '') i.disabled = true;
        });
      });

      const close = () => {
        sheet.hidden = true;
        document.documentElement.style.overflow = '';
      };
      this.querySelector('[data-sheet-open]')?.addEventListener('click', () => {
        sheet.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });
      this.querySelector('[data-sheet-close]')?.addEventListener('click', close);

      // filter groups: "Show N more" (snippets/c365-wall-filter.liquid)
      this.querySelectorAll('[data-wf-more]').forEach((btn) => {
        const more = btn.textContent;
        btn.addEventListener('click', () => {
          const open = btn.getAttribute('aria-expanded') !== 'true';
          btn.closest('.c365-wf').querySelectorAll('[data-more]').forEach((o) => (o.hidden = !open));
          btn.setAttribute('aria-expanded', String(open));
          btn.textContent = open ? btn.dataset.labelLess : more;
        });
      });
      // sort radios in the mobile sheet feed the toolbar select, the only sort_by the form sends
      const select = form.querySelector('select[name="sort_by"]');
      form.addEventListener('formdata', (e) => e.formData.delete('c365_sort'));
      this.querySelectorAll('[data-wf-sort]').forEach((r) => r.addEventListener('change', () => select && (select.value = r.value)));
      sheet.addEventListener('click', (e) => e.target === sheet && close());
    }
  }

  if (!customElements.get('c365-search')) customElements.define('c365-search', C365Search);
})();
